import React, { createContext, useContext, useState } from "react";
import { Spin } from "@arco-design/web-react";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoadings] = useState(false);

  const setLoading = (item) => {
    setLoadings((prev) => item);
  };

  return (
    <LoaderContext.Provider value={{ setLoading }}>
      <Spin loading={loading} dot>
        {children}
      </Spin>
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
